import {
  // useMutation,
  useQuery,
  // useQueryClient
} from "@tanstack/react-query";
import {
  getConfirmUser,
  getCurrentUser,
  getCompanyProfile,
  getTenants,
} from "../services/auth";
import { isTokenExpired } from "../lib/axios-client";

export const useConfirmUserEmail = ({ userId, token }) => {
  const { isPending, isError, data, error, isSuccess } = useQuery({
    queryKey: ["confirm_email", userId, token],
    queryFn: async () => {
      const response = await getConfirmUser({ userId, token });
      return response;
    },
    enabled: !!userId || !!token,
  });

  return { isPending, isError, data, error, isSuccess };
};

export const useGetCurrentUser = () => {
  const { isPending, isError, data, error, isSuccess } = useQuery({
    queryKey: ["current_user"],
    queryFn: async () => {
      const response = await getCurrentUser();
      return response;
    },
  });

  return { isPending, isError, data, error, isSuccess };
};

export const useCompanyProfile = () => {
  const raw = localStorage.getItem("authUser");
  const user = raw ? JSON.parse(raw) : null;

  const token = user?.accessToken;

  const expired = isTokenExpired(user?.accessTokenExpiresAtUtc);

  const { isPending, isError, data, error, isSuccess } = useQuery({
    queryKey: ["company_profile"],
    queryFn: async () => {
      const response = await getCompanyProfile();
      return response;
    },
    staleTime: 1000 * 60 * 60, // 1 hour
    enabled: !!token && !expired,
  });

  return { isPending, isError, data, error, isSuccess };
};

export const useGetTenants = (options = {}) => {
  const { enabled = true } = options;

  const { isPending, isError, data, error, isSuccess } = useQuery({
    queryKey: ["tenants"],
    queryFn: async () => {
      const response = await getTenants();
      return response;
    },
    enabled,
    staleTime: 5 * 60 * 1000,
  });

  return { isPending, isError, data, error, isSuccess };
};
